import CardContent from '@mui/material/CardContent';
import { Fade, Skeleton, Stack, Typography, useTheme } from '@mui/material';
import Card from '@mui/material/Card';

const EAStatistic = ({ title, subtitle, value, valueColor, isLoading = false, icon }) => {
  const theme = useTheme();
  return (
    <Card
      elevation={3}
      fullWidth
      sx={{
        borderRadius: 3,
        padding: '1em',
        textAlign: 'center',
        height: '100%',
      }}
    >
      <CardContent>
        <Stack spacing={1} alignItems="center">
          {icon && <span>{icon}</span>}

          <Typography variant="subtitle2" color="text.secondary">
            {title}
          </Typography>

          {subtitle &&
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          }

          {isLoading ? (
            <Skeleton variant="text" width={80} height={40} />
          ) : (
            <Fade in timeout={600}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 'bold',
                  color: valueColor ?? theme.palette.text.secondary,
                  letterSpacing: '2px',
                }}
              >
                {value ?? '-'}
              </Typography>
            </Fade>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default EAStatistic;
